var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5625L8.03125 7.28125C7.84375 7.4375 7.65625 7.5 7.5 7.5C7.3125 7.5 7.125 7.4375 6.96875 7.3125L0.96875 1.5625C0.65625 1.28125 0.65625 0.78125 0.9375 0.5C1.21875 0.1875 1.71875 0.1875 2 0.46875L7.5 5.71875L12.9688 0.46875C13.25 0.1875 13.75 0.1875 14.0312 0.5C14.3125 0.78125 14.3125 1.28125 14 1.5625Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyDownIcon);
export default __webpack_public_path__ + "static/media/KeyDownIcon.27d343441fbd7124d17fc03a91d8bb86.svg";
export { ForwardRef as ReactComponent };